'use client';

import { Link } from 'react-router-dom';
import { PageSEO } from '@/seo/PageSEO';

export function NotFound() {
  return (
    <main className="container" style={{ padding: '40px 0 70px' }}>
      <PageSEO
        title="404 | Bondex Sünger"
        description="Aradığınız sayfa bulunamadı. Bondex sünger ve Bariyerli Bondex ürünlerini inceleyin."
        pathname="/404"
        noIndex
      />
      <h1>Sayfa bulunamadı</h1>
      <p style={{ color: 'var(--muted)' }}>
        Aradığınız sayfa taşınmış olabilir. Ürünlerimizi görmek için ürünler sayfasına geçebilirsiniz.
      </p>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 16 }}>
        <Link className="btn btnPrimary" to="/">
          Anasayfa
        </Link>
        <Link className="btn" to="/urunler">
          Ürünler
        </Link>
      </div>
    </main>
  );
}
